import React, { useEffect, useState } from 'react'
import styles from './candidate.module.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEnvelope, faPhone, faPhoneAlt, faUnlock } from '@fortawesome/free-solid-svg-icons'
import Profile from '../../../assets/images/profielmodal.png'
import { Image } from 'react-bootstrap'
import { profileDetail } from '../../../action/databaseSearch'
import styled from 'styled-components';

import userlogo from '../../../assets/images/user.png'

import moment from 'moment'

const PDFObject = styled.object`
    width: 100%; /* Adjust width as needed */
    height: 1000px; /* Adjust height as needed */
`;
const Index = ({ data, onClose }) => {
  const [pdfData, setPdfData] = useState(null);

  const [activeTab, setActiveTab] = useState('home');
  const [details, setDetails] = useState(null);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_BASE_URL}/resume/${details?.CANDIDATE_ID}/${details?.RESUME_FILE}`)
      .then((res) => res.json())
      .then((data) => setPdfData(data.data))
      .catch((err) => console.error(err));
  }, [details]);

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  useEffect(() => {
    profileDetail(data.CANDIDATE_ID).then((res) => {
      if (res.status) {
        setDetails(res.result);
      }
    })

  }, [])
  return (
    <div className={`${styles['box-ct']}`}>
      <div className="position-relative">
        {/* Close Button */}
        <button
          className="btn active position-absolute top-0 end-0 m-2"
          onClick={() => onClose()}
          aria-label="Close"
        >
          &times;
        </button>

        {/* Profile Header */}
        <div className="d-flex align-items-center mb-2">
          <div className={`${styles['userimg-icon']} me-2`}>
            <Image
              src={
                details?.PROFILE_IMAGE
                  ? `${process.env.REACT_APP_BASE_URL}/candidate/pic/${details?.CANDIDATE_ID}/${details?.PROFILE_IMAGE}`
                  : userlogo
              }
              className="rounded-circle"
              alt="Candidate"
            />
          </div>
          <div>
            <h5 className={`${styles['ct-title']} mb-1`}>
              {details?.FIRST_NAME + ' ' + details?.SECOND_NAME.replace('undefined', '')}
            </h5>
            <p className={`${styles['call-ct']}`}>
              <FontAwesomeIcon className={`${styles['icon-bg']}`} icon={faPhone} />
              <span className="ps-2">{details?.PHONENO || 'XXXXXXXXXX'}</span>
            </p>
            <p className={`${styles['mail-ct']}`}>
              <FontAwesomeIcon className={`${styles['icon-bg']}`} icon={faEnvelope} />
              <span className="ps-2">{details?.EMAIL_ID || 'XXXXXXXXXXX'}</span>
            </p>
          </div>
        </div>
      </div>

      <ul className="nav nav-tabs border-0 nav-justified" id="myTab" role="tablist">
        <li className="nav-item" role="presentation">
          <button
            className={`nav-link ${activeTab === 'home' ? 'active' : ''}`}
            id="home-tab"
            data-bs-toggle="tab"
            type="button"
            role="tab"
            aria-controls="home"
            aria-selected={activeTab === 'home'}
            onClick={() => handleTabClick('home')}
          >
            Full Profile
          </button>
        </li>
        <li className="nav-item" role="presentation">
          <button
            className={`nav-link ${activeTab === 'profile' ? 'active' : ''}`}
            id="profile-tab"
            data-bs-toggle="tab"
            type="button"
            role="tab"
            aria-controls="profile"
            aria-selected={activeTab === 'profile'}
            onClick={() => handleTabClick('profile')}
          >
            CV / Resume
          </button>
        </li>
      </ul>
      <div className="tab-content" id="myTabContent">
        <div className={`tab-pane fade ${activeTab === 'home' ? 'show active' : ''}`} id="home" role="tabpanel" aria-labelledby="home-tab">


          <div className="p-3">
            <div className='my-3'>
              <h6 className={`${styles['ct-title']} mb-2`}>AI Message</h6>

              <p >
                {data.JUSTIFICATION}
              </p>


            </div>
            {details?.work_experience.length > 0 && <div className='my-3'>
              <h6 className={`${styles['ct-title']} mb-2`}>Work Experience</h6>
              {details?.work_experience?.map(item => (
                <p key={item.id}>
                  {item.CURRENT_DESIGNATION} at {item.CURRENT_COMPANY} |{' '}
                  <strong>
                    {moment(item.JOINING_DATE_MONTH).format('MMM') + ' ' + item.JOINING_DATE_YEAR} -
                    {item.IS_THIS_YOUR_CURRENT_COMPANY === 'N'
                      ? moment(item.WORKING_TILL_DATE_MONTH).format('MMM') + ' ' + item.WORKING_TILL_DATE_YEAR
                      : 'Present'}
                  </strong>
                </p>
              ))}

            </div>}
            {details?.INDUSTRY && <div className='my-3'>
              <h6 className={`${styles['ct-title']} mb-2`}>Industries</h6>
              <span className={`${styles['ct-badge']}`}>{details?.INDUSTRY}</span>
            </div>}
            {details?.ROLE_CATEGORY_NAME && <div className='my-3'>
              <h6 className={`${styles['ct-title']} mb-2`}>Role Category</h6>
              <span className={`${styles['ct-badge']}`}>{details?.ROLE_CATEGORY_NAME}</span>
            </div>}
            {/* <div className='my-3'>
              <h6 className={`${styles['ct-title']} mb-2`}>Role</h6>
              <span className={`${styles['ct-badge']}`}>{details?.ROLE_NAME}</span>
            </div> */}
            {details?.education?.length > 0 && <div className='my-3'>
              <h6 className={`${styles['ct-title']} mb-2`}>Education</h6>
              {details?.education?.map((item) => {
                return (
                  <span className={`${styles['ct-badge']}`}>{item?.COURSE_STREAM}, {item?.SPECIALIZATION} at {item?.UNIVERSITY_INSTITUTE}</span>
                )
              })}
            </div>}
            {details?.total_skill.length > 0 && <div className='my-3'>
              <h6 className={`${styles['ct-title']} mb-2`}>Skills</h6>
              <div>
                {details?.total_skill?.map((skill) => (
                  <span key={skill.SKILL} className={`${styles['ct-badge']}`}>{skill.SKILL}</span>
                ))}
              </div>
            </div>}
            {details?.PreferredWorkLocations.length > 0 && <div className='mb-3'>
              <h6 className={`${styles['ct-title']} mb-2`}>Preferred Location</h6>
              <div>
                {details?.PreferredWorkLocations?.map((city) => (
                  <span key={city.CITY} className={`${styles['ct-badge']}`}>{city.CITY}</span>
                ))}
              </div>
            </div>}
            {/* <div className='mb-3'>
              <h6 className={`${styles['ct-title']} mb-2`}>Languages</h6>
              <div>
                {["English", "Hindi", "Kannada"].map((lang) => (
                  <span key={lang} className={`${styles['ct-badge']}`}>{lang}</span>
                ))}
              </div>
            </div> */}
            {/* <div className='mb-3'>
              <h6 className={`${styles['ct-title']} mb-2`}>Asset & Documents</h6>
              <div>
                {["Bike", "Wifi", "Smartphones"].map((assets) => (
                  <span key={assets} className={`${styles['ct-badge']}`}>{assets}</span>
                ))}
              </div>
            </div> */}
            <div className='row'>
              <div className='col-md-7'>
                <h6 className={`${styles['ct-title']} mb-2`}>Personal Details</h6>
                <div className={`${styles['inner-data']}`}>
                  <p><strong>Experience:</strong> {details?.TOTAL_EXP_YEAR ? details?.TOTAL_EXP_YEAR + ' Years' : ''} {details?.TOTAL_EXP_MONTH ? details?.TOTAL_EXP_MONTH + ' Months' : ''}</p>
                  <p><strong>Age:</strong> {details?.DOB ? new Date().getFullYear() - new Date(details.DOB).getFullYear() - (new Date() < new Date(new Date(details.DOB).setFullYear(new Date().getFullYear())) ? 1 : 0) : "NA"}</p>

                  <p><strong>Role:</strong> {details?.ROLE_NAME ? details?.ROLE_NAME : 'NA'}</p>
                  {/* <p><strong>Location:</strong> Bangalore, Karnataka</p> */}
                  <p><strong>Gender:</strong> {details?.GENDER ? details?.GENDER : 'NA'}</p>
                </div>
              </div>
              {/* <div className='col-md-5'>
                <div className={`${styles['bg-profile']}`}>
                  <div className="d-flex align-items-center mb-2">
                    <div className='me-2'>
                      <Image src={Profile} className='rounded-circle' />
                    </div>
                    <div>
                      <h5 className={`${styles['ct-title']} mb-1`}>Shreya Thapa</h5>
                      <p className={`${styles['call-ct']}`}>
                        <FontAwesomeIcon className={`${styles['icon-bg']}`} icon={faPhone} /><span className='ps-2'>+91 XXXXXXXXXX</span>
                      </p>
                      <p className={`${styles['mail-ct']}`}>
                        <FontAwesomeIcon className={`${styles['icon-bg']}`} icon={faEnvelope} /><span className='ps-2'>user12@gmail.com</span>
                      </p>
                      <a href='#' className={`${styles['btn-ct']} btn w-100`}><FontAwesomeIcon icon={faUnlock} className='pe-2' />Unlock Profile</a>
                    </div>
                  </div>
                </div>
              </div> */}
            </div>
          </div>
        </div>
        <div className={`tab-pane fade ${activeTab === 'profile' ? 'show active' : ''}`} id="profile" role="tabpanel" aria-labelledby="profile-tab">
          {!details?.isUnlocked ? (
            <div style={{ textAlign: 'center', padding: '20px', color: 'red' }}>
              <p><strong>This PDF is locked.</strong></p>
              <p>Please contact support to unlock access.</p>
            </div>
          ) : (
            <PDFObject
              data={pdfData}
              width="100%"
              height="600px"
            />
          )}
        </div>
      </div>
    </div>
  )
}

export default Index